module.exports = __webpack_public_path__ + "static/fonts/NeueAugenblick-ExtraBold.6f11336a.woff";